import { Browser, OperatingSystems, UserAgentResource } from "./types";

/** *** */
/* Get information from UserAgent. Note! The logic can become obsolete at any time and then needs to be updated. */
/** *** */
const find = (value: string): boolean => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf(value) !== -1;
};

const isTouchDevice: boolean =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

// *** Devices ***
const isWindows = (): boolean => find("windows");
const isWindowsPhone = (): boolean => isWindows() && find("phone");
const isWindowsTablet = (): boolean =>
    isWindows() && isTouchDevice && !isWindowsPhone();

const isIpod = (): boolean => find("ipod");
const isIphone = (): boolean => !isWindows() && find("iphone");
const isIpad = (): boolean => {
    const iPadOS13Up = /Macintosh/.test(navigator.userAgent) && isTouchDevice;
    return find("ipad") || iPadOS13Up;
};
const isIos = (): boolean => isIpod() || isIphone() || isIpad();

const isMacOs = (): boolean => !isIos() && find("mac");

const isAndroid = (): boolean => !isWindows() && find("android");
const isAndroidPhone = (): boolean => isAndroid() && find("mobile");
const isAndroidTablet = (): boolean =>
    isAndroid() && !find("mobile") && isTouchDevice;

const isBlackberry = (): boolean => find("blackberry") || find("bb10");
const isBlackberryPhone = (): boolean => isBlackberry() && !find("tablet");
const isBlackberryTablet = (): boolean => isBlackberry() && find("tablet");

const isMobile = (): boolean =>
    isAndroidPhone() ||
    isIphone() ||
    isIpod() ||
    isWindowsPhone() ||
    isBlackberryPhone();

const isTablet = (): boolean =>
    isIpad() || isAndroidTablet() || isBlackberryTablet() || isWindowsTablet();

const isDesktop = (): boolean => !isTablet() && !isMobile() && !isTouchDevice;

export const userAgentDevices = {
    isWindows,
    isMacOs,
    isIos,
    isAndroid,
    isBlackberry,
    isMobile,
    isTablet,
    isDesktop,
};
//* *** */

// *** Browsers ***
const isDektopSafari = (): boolean =>
    isMacOs() && find("safari") && !find("chrome");
const isMobileSafari = (): boolean => isIos() && find("version/");
const isSafari = (): boolean => isDektopSafari() || isMobileSafari();

const isIosChrome = (): boolean => find("crios/");
const isChrome = (): boolean => find("chrome/") || isIosChrome();

export const userAgentBrowsers = {
    isChrome,
    isSafari,
};
//* *** */

export const getUserAgentResource = (): UserAgentResource => {
    const userAgentData = {
        ...userAgentDevices,
        ...userAgentBrowsers,
    };

    return {
        operatingSystem: userAgentData.isIos()
            ? OperatingSystems.IOS
            : userAgentData.isAndroid()
            ? OperatingSystems.ANDROID
            : OperatingSystems.OTHER,
        browser: userAgentData.isSafari()
            ? Browser.SAFARI
            : userAgentData.isChrome()
            ? Browser.CHROME
            : Browser.OTHER,
    };
};
